export default "__VITE_ASSET__RALasZDy__"